// src/store/modules/user.js
import axios from '@/plugins/axios';

const state = {
    user: null, // 存储当前用户的信息
};

const getters = {
    /**
     * 获取当前用户的信息
     */
    currentUser: (state) => state.user,

    /**
     * 获取当前用户的角色
     */
    userRole: (state) => state.user?.role || '',
};

const actions = {
    /**
     * 获取当前用户的信息
     */
    async fetchUser({ commit }) {
        try {
            const response = await axios.get('/admin/getUserInfo');
            console.log('API Response (fetchUser):', response);
            if (response && response.code === 200 && response.data) {
                commit('setUser', response.data);
            } else {
                console.error('API 返回的数据结构不正确:', response);
            }
        } catch (error) {
            console.error('获取用户数据失败:', error);
            throw error;
        }
    },

    /**
     * 更新当前用户的信息
     * @param {Object} userData - 更新后的用户数据
     */
    async updateUser({ commit }, userData) {
        try {
            // 假设更新用户信息的 API 路径为 /admin/users/updateUser
            const response = await axios.put('/admin/users/updateUser', userData);
            if (response.code === 200 && response.data) {
                commit('updateUser', response.data);
            } else {
                console.error('更新用户信息失败:', response.msg);
                throw new Error(response.msg || '更新用户信息失败');
            }
        } catch (error) {
            console.error('更新用户信息失败:', error);
            throw error;
        }
    },
};

const mutations = {
    /**
     * 设置当前用户的信息
     * @param {Object} state - Vuex state
     * @param {Object} user - 用户信息对象
     */
    setUser(state, user) {
        state.user = user;
    },

    /**
     * 更新当前用户的信息
     * @param {Object} state - Vuex state
     * @param {Object} updatedUser - 更新后的用户信息
     */
    updateUser(state, updatedUser) {
        if (state.user && state.user.userId === updatedUser.userId) {
            state.user = { ...state.user, ...updatedUser };
        } else {
            console.error('找不到对应的用户，无法更新');
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
